
export class Manufacturer {
    id: string;
    name: string;
    operator: string;
}
